module.exports = __webpack_public_path__ + "img/bj48.dcefa182.png";